import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import VrboUpdatePropertyOptionsForm, {
    ALL_VRBO_UPDATE_PROPERTY_OPTIONS,
    hasVrboUpdatePropertySelection,
    VrboUpdatePropertyOptions,
} from "./VrboUpdatePropertyOptionsForm";

export default function VrboUpdatePropertyModal(
    props: {
        active: boolean
        onClose: () => void
        onConfirm: (options: VrboUpdatePropertyOptions) => void
    }
) {
    const { active, onClose, onConfirm } = props

    const [options, setOptions] =     useState<VrboUpdatePropertyOptions>(ALL_VRBO_UPDATE_PROPERTY_OPTIONS)

        useEffect(() => {
            if (active) setOptions(ALL_VRBO_UPDATE_PROPERTY_OPTIONS)
        }, [active])
    return (
        <Modal show={active} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>Update VRBO Property</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Select what you want to update on VRBO:</p>
                <VrboUpdatePropertyOptionsForm options={options} onChange={setOptions} />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => onConfirm(options)} disabled={!hasVrboUpdatePropertySelection(options)}>
                    Update
                </Button>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
